import { getGoogleMapsConfig, getStableMapLanguage, UNIFIED_MAP_LIBRARIES } from "./GoogleMapApiConfig";

/**
 * [SINGLETON] Google Maps Loader Configuration
 * Returns a stable configuration object for useJsApiLoader.
 * This ensures consistency across the entire application (Admin + Booking).
 * 
 * @param {object} settings - Global settings object (from Redux) containing apiKey, etc.
 * @returns {object|null} Configuration object or null if apiKey is missing.
 */
export const getGoogleMapsLoaderConfig = (settings) => {
    // 0. Resolve Config using shared helper
    const config = getGoogleMapsConfig(settings);

    // 1. Validation: Fail fast if no settings or no API Key
    if (!settings || !config.apiKey) {
        console.warn("[GoogleMapsConfig] No API Key available. Loader will not initialize.");
        return null;
    }

    // 2. Stable Language (e.g. 'fr' or 'en', derived from URL or Default)
    const language = getStableMapLanguage({ pathname: window.location.pathname });

    // 3. Stable Region (Default FR if missing)
    const region = config.region || "FR";

    // 4. Construct Options
    const options = {
        id: "google-map-script", // CRITICAL: Must be identical everywhere
        googleMapsApiKey: config.apiKey,
        language: language,
        region: region,
        libraries: UNIFIED_MAP_LIBRARIES, // Stable array reference
        mapIds: config.mapId ? [config.mapId] : [], // Dynamic mapIds
        version: "weekly",
        preventGoogleFontsLoading: true
    };

    // 5. Freeze to prevent accidental mutations
    return Object.freeze(options);
};
